export default "/images/80e72d876826e52ff9aec00acaa1787d.avif";